<template>
  <div class="publicMain">
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="体检医院">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="体检日期">
          <el-col :span="11">
            <el-date-picker style="width:100%" type="date" placeholder="选择日期" v-model="form.date1"></el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align:center">-</el-col>
          <el-col :span="11">
            <el-time-picker placeholder="选择时间" v-model="form.date2" style="width:100%"></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="add" size="add">新增</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'" style="display:flex;justify-content: center;">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip
                class="item"
                style="color:#dd3020;"
                effect="light"
                content="删除"
                placement="top-start"
              >
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
            </div>
            <div v-else-if="item.type=='state'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.state==1">待审核</el-tag>
                <el-tag v-if="scope.row.state==2" type="success">通过</el-tag>
                <el-tag v-if="scope.row.state==3" type="danger">不通过</el-tag>
              </div>
            </div>
            <div v-else-if="item.type=='sex'">
              <div style="text-align:center;">
                <span v-if="scope.row.sex==0" type="success">男</span>
                <span v-if="scope.row.sex==1" type="primary">女</span>
              </div>
            </div>
            <div v-else-if="item.type=='nature'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.nature==1" type="success">农村户口</el-tag>
                <el-tag v-if="scope.row.nature==2" type="warning">城镇户口</el-tag>
                <el-tag v-if="scope.row.nature==3" type="danger">无户口</el-tag>
              </div>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible" width="40%">
      <div style="width:100%; width: 90%;margin: 0px auto;">
        <el-form
          v-if="visible"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="体检医院" prop="hospital">
            <el-input v-model="ruleForm.hospital"></el-input>
          </el-form-item>
          <el-form-item label="体检日期" prop="testTime">
            <el-date-picker
              style="width:60%"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd hh:mm:ss"
              value-format="yyyy-MM-dd hh:mm:ss"
              v-model="ruleForm.testTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="体检结果" prop="result">
            <el-input type="textarea" v-model="ruleForm.result"></el-input>
          </el-form-item>
          <el-form-item label="下次体检日期" prop="nextTime">
            <el-date-picker
              style="width:60%"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd hh:mm:ss"
              value-format="yyyy-MM-dd hh:mm:ss"
              v-model="ruleForm.nextTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="体检附件" prop="name">
            <upload
              :fileLists="fileList"
              :type="typeImg"
              @success="successImg"
              @deleteImg="deleteImg"
            />
          </el-form-item>
          <div class="button">
            <div class="button-mid" v-if="title!='查看'">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
            <div class="button-mid" v-else style="justify-content: center;">
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  oldManPhysicalEdit,
  oldManPhysicalCheck,
  oldManPhysicalList,
  oldManPhysicalDelete,
} from "../api";
//救助管理
import request from "@/utils/request.js";

import upload from "@/component/componentsP/upImg.vue";
export default {
  components: {
    upload,
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      title: "", //dialog的标题
      visible: false, //dialog的标题
      //模糊查询数据
      form: {},
      fileList: [],
      typeImg: "",
      visibleShow: false, //
      //table表格的column
      tableColumn: [
        {
          prop: "hospital",
          label: "体检医院",
        },
        {
          prop: "testTime",
          label: "体检日期",
        },
        {
          prop: "result",
          label: "体检结果",
        },
        {
          prop: "nextTime",
          label: "下次日期",
        },
        {
          label: "操作",
          type: "button",
        },
      ],

      //table表格的数据
      tableData: [],
      buttonType: false,
      row: {},
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      ruleForm: {},
      rulesDialog: {},
      rules: {
        hospital: [
          { required: true, message: "请填写体检医院", trigger: "blur" },
        ],
        testTime: [
          { required: true, message: "请填写体检日期", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //查询
    onCheck() {
      this.oldManPhysicalListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form,
      });
      this.$message({
        message: "查询成功",
        type: "success",
      });
    },
    //重置
    onReset() {
      this.form = {};
      this.oldManPhysicalListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      this.$message({
        message: "重置成功",
        type: "success",
      });
    },
    //每页请求${val}条数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.oldManPhysicalListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      });
    },
    //请求第${val}页数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.oldManPhysicalListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      });
    },
    //拿到列表
    oldManPhysicalListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        oldPeopleId: this.$route.query.id,
      });
      oldManPhysicalList(params).then((res) => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //新增按钮
    add() {
      this.visible = true;
      this.title = "新增";
      this.ruleForm = {};
      this.fileList = []
      this.typeImg = 'compile'
      // this.$refs.ruleForm.clearValidate()
    },
    //查看
    check(e) {
      this.visible = true;
      this.getData(e.id);
      this.title = "查看";
    },
    //编辑
    compile(e) {
      this.visible = true;
      this.getData(e.id);
      this.title = "编辑";
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          oldManPhysicalDelete({ id: e.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.oldManPhysicalListAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //保存
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let resultEnclosure = "";
          console.log('this.fileList',this.fileList);
          if (this.fileList && this.fileList.length > 0) {
            this.fileList.forEach((item) => {
              resultEnclosure = resultEnclosure + item.path + ";";
            });
          }
          this.ruleForm = Object.assign({}, this.ruleForm, {
            oldPeopleId: this.$route.query.id,
            resultEnclosure,
          });
          oldManPhysicalEdit(this.ruleForm).then((res) => {
            this.$message({
              type: "success",
              message: this.title == "新增" ? "新增成功" : "编辑成功",
            });
            this.visible = false;
            this.oldManPhysicalListAPI();
          });
        }
      });
    },
    //回写数据
    getData(e) {
      oldManPhysicalCheck({ id: e }).then((res) => {
        this.ruleForm = Object.assign({}, res.content, {});
        if (res.content.resultEnclosure) {
          let arr = res.content.resultEnclosure.split(";");
          arr.pop();
          this.fileList = arr.map((item) => {
            return {
              path: item,
              name: item,
            };
          });
          this.typeImg = "compile";
        }
      });
    },
    successImg(e) {
      console.log('e',e);
      this.fileList = e;
    },

    deleteImg(e) {
      this.fileList = e;
    },
  },
  created() {
    this.oldManPhysicalListAPI();
  },
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
  padding: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 50%;
  display: inline-block;
  float: right;
}
.el-form-item__label {
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.el-radio {
  margin: 10px;
}
.button-mid {
  width: 300px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
}
</style>
